import React, { useEffect } from 'react';
import './TerminosComponent.css';

export const TerminosComponent = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='terminos'>
        <div className='terminos-container'>
        <h1 className='titulo-page'>{props.I18n.TermsAndConditions}</h1>
        <ul>
            <li>
                <p>{props.I18n.TermsandConditionsP1}</p>
            </li>
        </ul>
        <h2>{props.I18n.UseOfTheSite}</h2>
        <ul>
            <li>
                <p>{props.I18n.TermsandConditionsP2}</p>
            </li>
            <li>
                <p>{props.I18n.TermsandConditionsP3}</p>                
            </li>
        </ul>
        <h2>{props.I18n.IntellectualProperty}</h2>
        <ul>
            <li>
                <p>{props.I18n.TermsandConditionsP4}</p>
            </li>
            <li>
                <p>{props.I18n.TermsandConditionsP5}</p>
            </li>
        </ul>
        <h2>{props.I18n.LimitationOfLiability}</h2>
        <ul>
            <li>
                <p>{props.I18n.TermsandConditionsP6}</p>
            </li>
            <li>
                <p>{props.I18n.TermsandConditionsP7}</p>
            </li>
        </ul>
        <h2>{props.I18n.LinksToThirdParties}</h2>
        <ul>
            <li>
                <p>{props.I18n.TermsandConditionsP8}</p>
            </li>
            <li>
                <p>{props.I18n.TermsandConditionsP9}</p>
            </li>
        </ul>
        <h2>{props.I18n.Modifications}</h2>
        <ul>
            <li>
                <p>{props.I18n.TermsandConditionsP10}</p>
            </li>
            <li>
                <p>{props.I18n.TermsandConditionsP11}</p>
            </li>
        </ul>
        <h3>{props.I18n.JurisdictionAndApplicableLaw}</h3>
        <ul>
            <li>
                <p>{props.I18n.TermsandConditionsP12}</p>
            </li>
            <li>
                <p>{props.I18n.TermsandConditionsP13}</p>
            </li>
        </ul>
        <h3>{props.I18n.LastUpdate}</h3>
        <ul>
            <li>
                <p>{props.I18n.TermsandConditionsP14}</p>
            </li>
        </ul>
    </div>

    </div>
    
  );
}
